import React, { useMemo } from "react";
import RepeatableField from "@components/RepeatableField/RepeatablePrimitiveField";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import {
  buildCountryOptions,
  syncDuplicateCountryErrors,
} from "@features/port-security/components/utils";
import type { PortSecurityFormData } from "@features/port-security/schema/portSecurityFormSchema.ts";
import { usePortSecurityFormStore } from "@features/port-security/store/usePortSecurityForm.store.ts";
import { useFormattedReference } from "@hooks/useFormattedReference";
import { REFERENCE_DATA_TYPES } from "@services/referenceDataApi";
import { stringToTitleCase } from "@utils/formatters/strings";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const CountriesVisited: React.FC = () => {
  const { formData } = useOutletContext<FormContext>();
  const { options: countries } = useFormattedReference<{
    countryName: string;
    countryCode: string;
  }>(REFERENCE_DATA_TYPES.COUNTRIES, "bff-gatepass");

  const countryOptions = useMemo(
    () => buildCountryOptions(countries, { valueMode: "code", formatName: stringToTitleCase }),
    [countries],
  );
  return (
    <FormProvider {...formData}>
      <RepeatableField
        name="countriesVisited"
        sectionLabel={t("security-clearance.countries-visited")}
        label={t("security-clearance.country")}
        onFieldChange={(key, arr) => {
          syncDuplicateCountryErrors(
            arr,
            "countriesVisited",
            formData.setError,
            formData.clearErrors,
            t,
          );
          usePortSecurityFormStore.getState().setField(key as keyof PortSecurityFormData, arr);
        }}
        maxItems={8}
        testId="countriesVisited"
        type="autocomplete"
        options={countryOptions}
      />
    </FormProvider>
  );
};

export default CountriesVisited;
